module.exports = __webpack_public_path__ + "img/AT0000002617346.1b0e80e4.png";